import { useMemo, useRef } from 'react';
import type { ExtendedPlaceholderContentItemModel } from 'autogen/swagger/all';
import ContentCard from 'components/ContentCard';
import { Slide } from 'components/emblaCarousel';
import { mapResponsiveImageModelToImageProps } from 'components/generic/Image/helpers/mapToImageProps';
import { guardIsPageActionOfTypeLinkAction } from 'components/shared/Routing/components/shared/helpers';
import useAdformImpressionTracking from 'hooks/tracking/useAdformImpressionTracking';
import { postAdformClickTracking } from 'modules/tracking/adformClickTracking';

export default function ArticleContentItem({
    item,
    ...restProps
}: {
    item: ExtendedPlaceholderContentItemModel;
}): JSX.Element {
    const { heading, dataLayer, pageAction, overline, image, adformImpTrackingUrls, adformClickTrackingUrl } = item;
    const ref = useRef(null);
    const imageProps = useMemo(() => (image ? mapResponsiveImageModelToImageProps(image) : undefined), [image]);
    const linkAction = guardIsPageActionOfTypeLinkAction(pageAction);
    const linkProps = linkAction ? { action: linkAction } : undefined;

    useAdformImpressionTracking({
        ref,
        impTrackingUrls: adformImpTrackingUrls
    });

    return (
        <Slide data-datalayer={JSON.stringify(dataLayer)} {...restProps}>
            <ContentCard
                ref={ref}
                image={imageProps}
                link={linkProps}
                heading={heading}
                subheading={overline}
                isTransparent
                onClick={adformClickTrackingUrl ? () => postAdformClickTracking(adformClickTrackingUrl) : undefined}
            />
        </Slide>
    );
}
